export default "__VITE_ASSET__DXmihBvW__"